import { render, staticRenderFns } from "./QuestionNode.vue?vue&type=template&id=32c91528&"
import script from "./QuestionNode.vue?vue&type=script&lang=js&"
export * from "./QuestionNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports